import React, { useState, useContext } from "react";
import "../styles/MobileLogin.css";
import Advert from "./Advert";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import api from "../context/api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SendexaPasswordReset() {
  const { phoneNumber, setPhoneNumber } = useContext(AuthContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const handlePhoneNumberChange = (value) => {
    setPhoneNumber(value);
  };

  const handleSendexaReset = async () => {
    if (!phoneNumber) {
      toast.error("Please enter a valid mobile number.");
      return;
    }

    const phoneNumberObj = parsePhoneNumberFromString(phoneNumber, "GH");

    if (!phoneNumberObj || !phoneNumberObj.isValid()) {
      toast.error("Invalid Phone Number. Please enter a valid phone number.");
      return;
    }

    const formattedPhoneNumber = phoneNumberObj.format("E.164");

    setIsLoading(true);
    try {
      const response = await api.post("/sendexa/password-reset", {
        phoneNumber: formattedPhoneNumber,
      });

      if (response.data?.success) {
        toast.success("OTP sent successfully.");
        navigate("/password-reset-sendexa-verify", {
          state: {
            phoneNumber: response.data.phoneNumber || formattedPhoneNumber,
            otpId: response.data.otpId || null,
          },
        });
      } else {
        toast.error(response.data?.message || "Failed to send reset message.");
      }
    } catch (error) {
      const message =
        error.response?.data?.message ||
        "An error occurred while sending reset message. Please try again.";
      toast.error(message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} />
      <div className="login-image-top"></div>
      <div className="login-box">
        <h1>Reset Your Password</h1>
        <p>Enter your phone number to receive a Sendexa OTP code</p>

        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSendexaReset();
          }}
        >
          <div className="input-group">
            <input
              type="tel"
              placeholder="Mobile Number (eg 054 099 0099)"
              value={phoneNumber}
              onChange={(e) => handlePhoneNumberChange(e.target.value)}
              required
            />
          </div>

          <button type="submit" disabled={isLoading}>
            {isLoading ? "Processing..." : "Send OTP"}
          </button>
        </form>

        <div className="links">
          <span>
            Back to default reset? <a href="#" onClick={() => navigate("/password-reset")}>Use existing flow</a>
          </span>
          <span>
            Remember your password? <a href="#" onClick={() => navigate("/login")}>Login</a>
          </span>
        </div>

        <p className="support-text">
          Having a problem? <a href="#">Contact support</a>
        </p>
      </div>
      <div style={{ marginTop: "90px", width: "100%" }}>
        <Advert />
      </div>
    </div>
  );
}
